// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__3AyOv","rootSuccess":"CompleteLink_rootSuccess__3rrGx","rootFailure":"CompleteLink_rootFailure__2w7IZ","isDisabled":"CompleteLink_isDisabled__188A5"};